import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { nbsApiMyLocation } from '../../../store/actions/myLocation';
import { removeSessionToken } from '../../../store/actions/session';
import { nbsWSClose } from '../../../store/actions/socket';
import {
  resetCreateAccountData,
  setUserCreateAccountData,
} from '../../../store/actions/createAccountData';
import CreateAccount from '../../../components/Auth/CreateAccountInline/CreateAccountInline';
import { deleteReduxStateFromStorage } from '../../../assets/helpers/utils';
import paths from '../../../constants/paths';
import strings from '../../../assets/localization';
import { gtmSignupStep } from '../../../assets/helpers/GAHelper';

class CreateAccountInlineContainer extends Component {
  state = { showAlert: false, errorMessage: null, showSpinner: false };

  componentDidMount() {
    if (this.props.createAccountData.stepIndex === 0) {
      this.props.innitialGoToStep && this.goToStep(this.props.innitialGoToStep);
      // set new gender and seeking
      this.props.genderNewDefault &&
        this.props.setUserCreateAccountData({
          gender: this.props.genderNewDefault,
        });
      this.props.seekingNewDefault &&
        this.props.setUserCreateAccountData({
          seeking: this.props.seekingNewDefault,
        });
    } else {
      this.goToStep(this.props.createAccountData.stepIndex);
    }
  }

  componentWillUnmount() {
    this._setHashTagForStep(0, true);
  }

  componentDidUpdate(prevProps) {
    // Handle Email Registration Success
    if (
      prevProps.emailRegister.status !== this.props.emailRegister.status &&
      this.props.emailRegister.status === 'success'
    ) {
      this._setHashTagForStep(6); // Set manually to step 6 after successful registration
    }

    // Handle Config Fetch Failure
    if (
      prevProps.getConfig.status !== this.props.getConfig.status &&
      this.props.getConfig.status === 'fail'
    ) {
      if (this.props.getConfig.error.error_code === 9999) {
        // Network error: Server is down
        nbsWSClose();
        this.props.removeSessionToken();
        deleteReduxStateFromStorage();
        alert(strings.networkError);
      }
    }
  }

  goBack = () => {
    const { stepIndex } = this.props.createAccountData;
    if (stepIndex === 0) {
      if (this.props.history.action === 'PUSH') {
        this.props.history.goBack();
      } else {
        this.props.history.push(paths.INDEX);
      }
      this.props.resetCreateAccountData();
    } else {
      switch (stepIndex) {
        case 1:
          gtmSignupStep('gender', 1, 5);
          break;
        case 2:
          gtmSignupStep('location', 2, 5);
          break;
        case 3:
          gtmSignupStep('age', 3, 5);
          break;
        case 4:
          gtmSignupStep('username', 4, 5);
          break;
        case 5:
          gtmSignupStep('email-password', 5, 5);
          break;
        default:
          gtmSignupStep('gender', 1, 5);
      }
      this.props.setUserCreateAccountData({ stepIndex: stepIndex - 1 });
    }
  };

  goToStep = (stepIndex) => {
    this._setHashTagForStep(stepIndex);
    if (stepIndex > 1) {
      switch (stepIndex) {
        case 2:
          gtmSignupStep('location', 2, 5);
          break;
        case 3:
          gtmSignupStep('age', 3, 5);
          break;
        case 4:
          gtmSignupStep('username', 4, 5);
          break;
        case 5:
          gtmSignupStep('email-password', 5, 5);
          break;
        default:
          gtmSignupStep('gender', 1, 5);
      }
    }
    this.props.setUserCreateAccountData({ stepIndex });
  };

  jumpToStep = (jumpStep) => {
    this.goToStep(jumpStep);
  };

  toggleAlertError = (errorMessage) => {
    this.setState({ showAlert: !this.state.showAlert, errorMessage });
  };

  _setHashTagForStep = (step, reset = false) => {
    if (!step || reset) {
      this.props.history.replace(
        this.props.history.location.pathname +
          this.props.history.location.search
      );
      return;
    }
    // make sure hash is only set for home page
    if (
      this.props.history.location.pathname !== paths.INDEX ||
      this.props.session.token
    ) {
      return;
    }
    this.props.history.replace(
      this.props.history.location.pathname +
        this.props.history.location.search +
        '#step' +
        step
    );
  };

  render() {
    // console.log('Create Account Inner CONTAINER RENDER:', this.props, this.state);
    return (
      <CreateAccount
        showSpinner={this.state.showSpinner}
        showErrorAlert={this.state.showAlert}
        errorAlertMessage={this.state.errorMessage}
        dismissAlert={this.toggleAlertError}
        isLandscape={this.props.isLandscape}
        step={this.props.createAccountData.stepIndex}
        goToStep={this.goToStep}
        jumpToStep={this.jumpToStep}
        goBack={this.goBack}
        toggleMinHeight={this.props.toggleMinHeight}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    myLocation: state.myLocation,
    createAccountData: state.createAccountData,
    getConfig: state.getConfig,
    session: state.session,
    emailRegister: state.emailRegister,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      nbsApiMyLocation,
      setUserCreateAccountData,
      resetCreateAccountData,
      removeSessionToken,
    },
    dispatch
  );
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateAccountInlineContainer);
